import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/InformationPopup.css";

interface InformationPopupProps {
  open: boolean;
  title: string;
  subTitle: string;
  buttonText: string;
  onClick: () => void;
  onClose: () => void;
}

const InformationPopup: React.FC<InformationPopupProps> = ({
  open,
  title,
  subTitle,
  buttonText,
  onClick,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "information-popup-container",
      }}
      BackdropProps={{
        className: "information-popup-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="information-popup-header">{title}</div>
        <div className="information-popup-divider"></div>
        <div className="information-popup-containt-container">
          <p>{subTitle}</p>
        </div>
        <div className="information-popup-button" onClick={onClick}>
          <div>{buttonText}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InformationPopup;
